<i18n lang="yaml">
  pt:
    success: "Projeto duplicado com sucesso"
    project-name: "Nome do projeto"
    project-url: "URL do projeto"
    clone-app: "Clonar projeto"
    clone-project: "Clonar projeto"
    select-default-item: "Selecione uma opção"
    project-goal: "Para qual finalidade o projeto será usado?"
    tutorial-text: "Tutorial: Criando e configurando app do zero"
    clone-warning: "A clonagem pode demorar alguns instantes"
</i18n>

<template>
  <Modal id="cloneApp">
    <template #modal-title>
      {{ $t('clone-project') }} "{{ cloningApp.name ?? '' }}"
    </template>

    <template #modal-content>
      <FormRequest
        :rules="rules"
        class="createapp"
        @on-submit="cloneApp"
        @on-submitted="destiny"
      >
        <template #default="{ loading: busy }">
          <div class="createapp__wrapper">
            <input
              name="id"
              type="hidden"
              :value="cloningApp.id ?? 0"
            >

            <BasicInput
              id="project-name"
              v-model="projectName"
              name="name"
              :title="$t('project-name')"
              placeholder="Loja X"
            />

            <BasicInput
              id="project-url"
              v-model="projectURL"
              name="url"
              class="mt-2"
              :title="$t('project-url')"
              placeholder="https://url.com"
            />

            <DefaultButton
              :busy="busy"
              type="submit"
              class="createapp__submit growing-effect w-100"
            >
              {{ $t('clone-app') }}

              <ArrowNarrowRightIcon />
            </DefaultButton>

            <p class="createapp__helperlinks text-center">
              {{ $t('clone-warning') }}
            </p>
          </div>
        </template>
      </FormRequest>
    </template>
  </Modal>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import Modal from '../../../grid/modal/index'
import BasicInput from '../../../global/BasicInput'
import DefaultButton from '../../../global/Button'
import FormRequest from '../../../core/form/Request.vue'
import ArrowNarrowRightIcon from '../../../icons/ArrowNarrowRightIcon'

export default defineComponent({
  name: 'ModalCloneApp',

  components: {
    Modal,
    BasicInput,
    FormRequest,
    DefaultButton,
    ArrowNarrowRightIcon
  },

  data () {
    return {
      projectURL: '',
      projectName: ''
    }
  },

  computed: {
    ...mapGetters({
      currentApp: 'apps/getApp',
      cloningApp: 'apps/getCloningApp'
    }),

    rules: () => ({
      name: 'required|min:2',
      url: 'required'
    })
  },

  methods: {
    ...mapActions({
      cloneApp: 'apps/cloneApp'
    }),

    ...mapMutations({
      setCloningApp: 'apps/SET_CLONING_APP'
    }),

    destiny () {
      this.setCloningApp({})

      this.emitter.emit('toggle-modal', 'cloneApp', false)

      this.emitter.emit('on-toast-show', {
        color: 'success',
        message: this.$t('success')
      })

      this.$router.push({ name: 'checklist-home', params: { appID: this.currentApp.id } })
    }
  }
})
</script>

<style lang="scss" scoped>
  .createapp {
    width: 520px;

    :deep(input) {
      height: 50px;
      flex-basis: 50px;

      color: rgb(var(--gray8));
      font: 400 1.6rem "Nunito", sans-serif;
    }

    &__submit {
      height: 50px;
      border-radius: 4px;
      margin: 40px auto 0;

      font: 700 1.8rem "Nunito", sans-serif;

      :deep(svg) {
        margin: 0 0 0 15px;
        transition: all .4s ease-in-out;
      }

      &:hover :deep(svg) {
        transform: translateX(5px);
      }
    }

    &__helperlinks {
      color: rgb(var(--orange1));
      font: 400 1.4rem "Nunito", sans-serif;
    }
  }
</style>
